/**
 * Fase 2B — LifecycleStatusBanner
 *
 * Toont bovenaan een historisch document een duidelijke Nederlandse waarschuwing:
 *  - Vervangen  → historische versie, nieuwe actief elders
 *  - Duplicaat  → dubbel; niet in documentenset/ZIP/e-mail
 *  - Geannuleerd → ongeldig verklaard
 *
 * Uitsluitend admin-UI. Geen PDF-wijzigingen.
 */
import React from "react";
import { History, Copy, XCircle } from "lucide-react";

const BANNER_CONFIG = {
  vervangen: {
    Icon: History,
    className: "border-l-4 border-zinc-500 bg-zinc-50 text-zinc-900",
    title: "Vervangen (historische versie)",
    body: "Dit is een historische versie. De actieve documentenset gebruikt een nieuwere versie.",
  },
  duplicaat: {
    Icon: Copy,
    className: "border-l-4 border-amber-500 bg-amber-50 text-amber-900",
    title: "Duplicaat",
    body: "Dit document is gemarkeerd als duplicaat en wordt niet gebruikt voor documentenset, ZIP of e-mail.",
  },
  geannuleerd: {
    Icon: XCircle,
    className: "border-l-4 border-rose-500 bg-rose-50 text-rose-900",
    title: "Geannuleerd",
    body: "Dit document is geannuleerd en wordt niet gebruikt in actieve processen.",
  },
};

export default function LifecycleStatusBanner({ status, reason, replacedBy, replacesId }) {
  const cfg = BANNER_CONFIG[status];
  if (!cfg) return null;
  const { Icon, className, title, body } = cfg;
  return (
    <div
      className={`${className} p-3 flex items-start gap-2 mb-3`}
      data-testid={`lifecycle-banner-${status}`}
    >
      <Icon className="w-4 h-4 mt-0.5 shrink-0" />
      <div className="text-xs">
        <div className="font-bold">{title}</div>
        <div className="mt-0.5">{body}</div>
        {reason && (
          <div className="mt-1 italic">Reden: {reason}</div>
        )}
        {replacedBy && (
          <div className="mt-1">
            Opvolger: <code className="bg-white px-1 border">{String(replacedBy).slice(0, 8)}</code>
          </div>
        )}
        {replacesId && (
          <div className="mt-1">
            Vervangt: <code className="bg-white px-1 border">{String(replacesId).slice(0, 8)}</code>
          </div>
        )}
      </div>
    </div>
  );
}
